(() => {
    const GRID_SEL = '.product-grid';
    const SWITCH_SEL = '.layout-switchers';

    const getInitialLayout = () => {
        const saved = localStorage.getItem('gridLayout');
        if (saved === '1' || saved === '2') return saved;
        const root = document.querySelector(SWITCH_SEL);
        if (root?.querySelector('.layout-switch--two-columns.layout-switch--active')) return '2';
        if (root?.querySelector('.layout-switch--one-column.layout-switch--active')) return '1';
        return '2';
    };

    const unhide = (el, type) => {
        if (!el) return;
        if (type === 'grid') el.classList.remove('grid-hidden');
        if (type === 'switcher') el.classList.remove('switcher-hidden');
        el.style.visibility = 'visible';
    };

    const applyLayout = (layout, scope = document) => {
        const isOne = layout === '1';

        scope.querySelectorAll?.(GRID_SEL).forEach((el) => {
            el.classList.remove('product-grid--per-row-mob-1', 'product-grid--per-row-mob-2');
            el.classList.add(isOne ? 'product-grid--per-row-mob-1' : 'product-grid--per-row-mob-2');
            unhide(el, 'grid');
        });

        scope.querySelectorAll?.(SWITCH_SEL).forEach((root) => {
            const btnOne = root.querySelector('.layout-switch--one-column');
            const btnTwo = root.querySelector('.layout-switch--two-columns');
            if (btnOne && btnTwo) {
                btnOne.classList.toggle('layout-switch--active', isOne);
                btnTwo.classList.toggle('layout-switch--active', !isOne);
                btnOne.setAttribute('aria-pressed', String(isOne));
                btnTwo.setAttribute('aria-pressed', String(!isOne));
            }
            unhide(root, 'switcher');
        });
    };

    const initLayout = () => applyLayout(getInitialLayout());

    // first paint / BFCache / Shopify section hooks
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initLayout, { once: true });
    } else {
        initLayout();
    }
    window.addEventListener('pageshow', initLayout);
    document.addEventListener('shopify:section:load', initLayout);
    document.addEventListener('shopify:section:reorder', initLayout);

    // jQuery themes: re-apply after any AJAX
    if (window.jQuery) {
        jQuery(document).on('ajaxComplete', initLayout);
    }

    // MutationObserver: handles AJAX pagination (including DocumentFragment inserts)
    let scheduled = false;
    const scheduleApply = () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
            scheduled = false;
            initLayout();
        });
    };

    const mo = new MutationObserver((mutations) => {
        for (const m of mutations) {
            for (const n of m.addedNodes) {
                if (n.nodeType === 1) {
                    if (n.matches?.(`${GRID_SEL}, ${SWITCH_SEL}`) || n.querySelector?.(`${GRID_SEL}, ${SWITCH_SEL}`)) {
                        scheduleApply();
                        continue;
                    }
                }
                // DocumentFragment (nodeType 11) — common for AJAX renders
                if (n.nodeType === 11 && n.querySelector?.(`${GRID_SEL}, ${SWITCH_SEL}`)) {
                    scheduleApply();
                }
            }
        }
    });

    if (document.body) {
        mo.observe(document.body, { childList: true, subtree: true });
    }
})();